<script>
import env from '@root/env';

export default {
  props: {
    dataModal: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data(){
    return {
      durationTypeOptions: {
        "M": "Minute",
        "H": "Hour",
        "D": "Day",
        "W": "Week",
        "MH": "Month",
      },
    }
  },
  computed: {
    moment(){ return global.moment },
  },
  methods: {
    durationType(type){
      return this.durationTypeOptions[type]||""
    },
    assets(type, filename){
      return env.staticImageUrl + "/" + type + (filename ? "/" + filename : "" );
    }
  }
}
</script>

<style scoped>
tr.item-centered td {
  vertical-align: middle;
  text-align: center;
}

thead.head-checklist {
  background: #203764;
  border: 1px solid #203764 !important;
  color: #FFF !important;
}

thead.head-checklist th {
  border: 1px solid #203764 !important;
  color: #FFF !important;
}
</style>

<template>
<div class="row justify-content-center">
  <div class="col-md-12">
    <table class="table table-striped table-bordered mt-3">
      <thead class="head-checklist">
        <tr>
          <th rowspan="3" style="width:25%;vertical-align:middle;" class="text-center">
            <img :src="assets('img','logo-onboarding-checklist1.png')" alt="user-img" style="width: 70px;object-fit:cover;">
          </th>
          <th style="width:50%;vertical-align:middle;">
            <h3 class="font-weight-bold text-center">{{ dataModal.title_form||'' }}</h3>
          </th>
          <th rowspan="3" width="width:25%;vertical-align:middle;" class="text-center">
            <img :src="assets('img','logo-onboarding-checklist2.png')" alt="user-img" style="width: 140px;object-fit:cover;">
          </th>
        </tr>

        <tr>
          <th class="vertical-align:middle;">
            <h6 class="text-center">{{ dataModal.description_form||'' }}</h6>
            <h6 class="text-center">({{ dataModal.description_form_en||'' }})</h6>
          </th>
        </tr>

        <tr>
          <th></th>
        </tr>

      </thead>

      <tbody>
        <tr>
          <td style="width: 20%">Nama (CWID)</td>
          <td colspan="2">
            : <strong>{{ dataModal.employeename }} ({{ dataModal.cwid }})</strong>
          </td>
        </tr>

        <tr>
          <td style="width: 20%">Job Position</td>
          <td colspan="2">
            : <strong>{{ dataModal.employee_position }}</strong>
          </td>
        </tr>

        <tr>
          <td style="width: 20%">Effective Join Date</td>
          <td colspan="2">
            : <strong>{{ moment(dataModal.effective_join_date).format('DD MMM YYYY') }}</strong>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Table Checklist -->    
    <table class="table table-striped table-bordered" v-for="(dataChecklist, kChecklist) in dataModal.checklist" :key="kChecklist">      
      <thead>
        <tr>
          <th colspan="5" style="background:#bde0ff;">
            <div class="row justify-content-center pt-3 pb-3">
              <div class="col-md-4">
                <div class="text-center">
                  <h6 class="font-weight-bold mb-0">{{ dataChecklist.title }}</h6>
                </div>
              </div>
            </div>
          </th>
        </tr>

      </thead>
      
      <tbody v-for="(dataItemChecklist, kItemChecklist) in dataChecklist.items" :key="kItemChecklist">
        <tr style="background:#f2f2f2;">
          <th style="vertical-align:middle;" colspan="2">
            <p class="text-center font-weight-bold mb-0">{{ dataItemChecklist.title }}</p>
          </th>

          <th style="vertical-align:middle;">
            <p class="text-center font-weight-bold mb-0">Duration</p>
          </th>

          <th style="vertical-align:middle;">
            <p class="text-center font-weight-bold mb-0">Responsible</p>
          </th>

          <th style="vertical-align:middle;">
            <p class="text-center font-weight-bold mb-0">Complete Date</p>
          </th>
        </tr>

        <tr v-for="(dataItemSubChecklist, kItemSubChecklist) in dataItemChecklist.subItems" :key="kItemSubChecklist" class="item-centered">
          <td style="width:5%;">
            <p class="text-center mb-0">
              {{ dataItemSubChecklist.is_done ? '✔' : '[]' }}
            </p>
          </td>
          <td>
            <p class="mb-0">{{ dataItemSubChecklist.name }}</p>
            <p class="mb-0" v-if="dataItemSubChecklist.name_en">({{ dataItemSubChecklist.name_en }})</p>

            <template v-if="dataItemSubChecklist.remarks">
              <hr>
              <span style="text-align: left !important;"><strong>Remarks: </strong> {{ dataItemSubChecklist.remarks }}</span>
            </template>
          </td>

          <td>
            <div class="text-center" v-if="dataItemSubChecklist.using_duration">
              <p class="mb-0">{{ dataItemSubChecklist.duration }} {{ durationType(dataItemSubChecklist.duration_type) }}</p>
            </div>

            <template v-else>
              <p class="mb-0">N/A</p>
            </template>
          </td>

          <td>
            <p class="text-center mb-0">
              {{ dataItemSubChecklist.verificator_name }}
            </p>
          </td>

          <td>            
            <p class="mb-0 text-center" v-if="dataItemSubChecklist.done_date">{{ moment(dataItemSubChecklist.done_date).format('DD MMM YYYY') }}</p>
            <p class="mb-0 text-center" v-else>-</p>
          </td>
        </tr>
      </tbody>

      <tbody>
        <tr>
          <td colspan="10" style="border:1px solid transparent; background: #FFF;">
            <div class="html2pdf__page-break" />
          </td>
        </tr>
      </tbody>
    </table>
    <!-- End Table Checlist -->
  </div>
</div>
</template>
